import * as React from 'react'
import { ReactElement } from 'react'
import { EntityComboboxProps } from './EntityCombobox'
import BaseCombobox from './BaseCombobox'
import useOrganisationProfiles from '../../hooks/useOrganisationProfiles'

export type OrganisationProfileDto = {
    key: string
    name: string
    enabled: boolean
    unit?: string
}

type Props = Partial<EntityComboboxProps<OrganisationProfileDto>> &
    Required<Pick<EntityComboboxProps<OrganisationProfileDto>, 'selectedOptions' | 'onOptionSelect'>>

export default function OrganisationProfileCombobox(props: Props): ReactElement {
    const { organisationProfiles } = useOrganisationProfiles()

    return (
        <BaseCombobox<OrganisationProfileDto>
            entities={organisationProfiles}
            alphabetical
            filter={entity => props.filter?.(entity) ?? (entity.enabled || props.selectedOptions?.includes(entity.key))}
            getEntityLabel={profile => profile.name}
            getEntityValue={profile => profile.key}
            placeholderKey={'base.organisationprofilecombobox.placeholder'}
            {...props}
        />
    )
}
